module.exports = __webpack_public_path__ + "img/DK.8c2e9db4.svg";